import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { TransportProvider } from '@connectrpc/connect-query'
import { connectTransport } from '../../lib/connect-transport'
import { reportError } from '../../lib/error-reporting'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (err) => reportError(err, { kind: 'query' }),
  }),
  mutationCache: new MutationCache({
    onError: (err) => reportError(err, { kind: 'mutation' }),
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
    },
  },
})

export function getContext() {
  return {
    queryClient,
  }
}

export function Provider({
  children,
  queryClient,
}: {
  children: React.ReactNode
  queryClient: QueryClient
}) {
  return (
    <TransportProvider transport={connectTransport}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </TransportProvider>
  )
}
